export const NEW_TEMPLATES_GALLERY_SEARCH = 'new_templates_gallery_search';
export const WEBSITE_HOMEPAGE_HERO_TEXTBOX_OR_BUTTONS = 'website_hompage_hero_textbox_or_buttons';
